import StudentService from '../../../modules/student/studentService'
import Errors from '../../../modules/shared/error/errors'
import Message from '../../../view/shared/message'
import { push } from 'redux-first-history'
import { i18n } from '../../../i18n'

const prefix = 'STUDENT_FORM'

const studentFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: studentFormActions.INIT_STARTED,
      })

      let record = {}

      const isEdit = Boolean(id)

      if (isEdit) {
        record = await StudentService.find(id)
      }

      dispatch({
        type: studentFormActions.INIT_SUCCESS,
        payload: record,
      })
    } catch (error) {
      Errors.handle(error)

      dispatch({
        type: studentFormActions.INIT_ERROR,
      })

      dispatch(push('/student'))
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: studentFormActions.CREATE_STARTED,
      })

      await StudentService.create(values)

      dispatch({
        type: studentFormActions.CREATE_SUCCESS,
      })

      Message.success(
        i18n('entities.student.create.success'),
      )

      dispatch(push('/student'))
    } catch (error) {
      Errors.handle(error)

      dispatch({
        type: studentFormActions.CREATE_ERROR,
      })
    }
  },

  doUpdate: (id, values) => async (dispatch, getState) => {
    try {
      dispatch({
        type: studentFormActions.UPDATE_STARTED,
      })

      await StudentService.update(id, values)

      dispatch({
        type: studentFormActions.UPDATE_SUCCESS,
      })

      Message.success(
        i18n('entities.student.update.success'),
      )

      dispatch(push('/student'))
    } catch (error) {
      Errors.handle(error)

      dispatch({
        type: studentFormActions.UPDATE_ERROR,
      })
    }
  },
}

export default studentFormActions
